import React from 'react';
import Button from '../components/Button';
import { Link } from 'react-router-dom';
import Lottie from 'lottie-react';
import Marketing from "../animation/service/Marketing.json";
import ContactFormPopup from '../components/ContactFormPopup';

const SubServiceDetailSection1 = ({ data, lottieSrc }) => {
  const {
    serviceName,
    breadcrumb = [],
    heading,
    illustration = {
      type: "lightbulb", // lightbulb, custom, or svg
      customSvg: null
    },
    backgroundColor = "bg-gray-50 dark:bg-zinc-800",
    dotPattern = true
  } = data;

  const [popUpActive, setPopupActive] = React.useState(false);



  return (
    <div className={`${backgroundColor} py-25 xl:px-35 px-10 relative overflow-hidden min-h-screen flex items-center`}>
      {/* Dot Pattern Background */}
      {/* {dotPattern && <DotPattern />} */}

      <div className="w-full">
        <div className="flex justify-between gap-0 items-center flex-col-reverse xl:flex-row">
          {/* Left Content */}
          <div className="space-y-8 relative z-10 xl:w-[60vw_!important] w-full text-center xl:text-left">
            {/* Service Name Header */}
            <div>
              <h1 className="text-2xl font-bold text-[#EE005B] mb-6">
                {serviceName}
              </h1>

              {/* Breadcrumb */}
              {breadcrumb.length > 0 && (
                <nav className="flex items-center space-x-2 text-sm w-[100%] justify-center xl:justify-start xl:w-fit text-gray-600 dark:text-gray-400 mb-8">
                  {breadcrumb.map((item, index) => (
                    <React.Fragment key={index}>
                      <span className={index === breadcrumb.length - 1 ? 'text-gray-400 dark:text-gray-500' : 'hover:text-pink-500 cursor-pointer'}>
                        {item}
                      </span>
                      {index < breadcrumb.length - 1 && (
                        <span className="text-gray-400">•</span>
                      )}
                    </React.Fragment>
                  ))}
                </nav>
              )}
            </div>

            {/* Main Heading */}
            <div>
              <h2 className={` ${data.headingTextSize ? data.headingTextSize : 'text-4xl'} font-bold text-black dark:text-white leading-tight`}>
                {heading.split('\n').map((line, index) => (
                  <React.Fragment key={index}>
                    {line}
                    {index < heading.split('\n').length - 1 && <br className='hidden xl:block' />}
                  </React.Fragment>
                ))}
              </h2>

              <Link onClick={() => setPopupActive(true)}>
                <Button className={"mt-10 px-10 text-lg"}>Let's Talk</Button>
              </Link>
            </div>
          </div>

          {/* Right Illustration */}
          <div className="flex justify-center items-center relative z-20 xl:w-[75%] h-full">
            <Lottie animationData={lottieSrc ?? Marketing} loop={true} className="w-full h-full object-contain" />
          </div>
        </div>
      </div>


      <ContactFormPopup isActive={popUpActive} onClose={() => setPopupActive(false)} />
    </div>
  );
};

export default SubServiceDetailSection1;
